import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { CopilotOutput } from 'libs/end-to-end/src/copilot';

export const HiringCopilotCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'hiringCopilot',
  isDataQueuingAllowed: true,
  outputFileName: 'hiring_copilot_output.json',
  outputSchema: CopilotOutput,
  resolveFocusArea: () => 'Hiring',
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.643,
    multiplier: 0.01495,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'hiringCopilot') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: [
        {
          columnHeaderValue: 'Location',
          values: request.inputs.dropdowns.location,
        },
        {
          columnHeaderValue: 'Job Title',
          values: request.inputs.dropdowns.job_title,
        },
        {
          columnHeaderValue: 'Department',
          values: request.inputs.dropdowns.department,
        },
        {
          columnHeaderValue: 'Start Date',
          values: request.inputs.dropdowns.start_date,
        },
        {
          columnHeaderValue: 'End Date',
          values: request.inputs.dropdowns.end_date,
        },
      ],
      'Selected Dimensions': [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'copilot/hiring',
};
